$(function () {

  $('#js-scrollTop>a').click(function () {
    var adjust = 0;
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
  $(".addSearch__text input").keypress(function (e) {
    if (e.which == 13) return $(".addSearch__text a")[0].click(), !1;
  }),
    $(".js-addHeader").show(),
    $(window).on("load", function () {
      function wait() {
        var nav_w = $(".nav__inner").outerWidth();
        (nav_w = -nav_w)/* , $(".nav__inner").css({ "margin-left": nav_w }) */;
      }
      $.when(wait()).done(function () {
        $("nav").show();
      });
    }),
    $(window).on("resize", function () {
      var windowWidth = $(window).width();
      if (!$(".js-nav__btn").hasClass("active")) {
        var nav_w = $(".nav__inner").outerWidth();
        (nav_w = -nav_w)/* , $(".nav__inner").css({ "margin-left": nav_w }) */;
      }
      $(".js-nav__btn").hasClass("active")
        ? windowWidth >= 768 &&
        $("#js-container").css({ position: "relative", top: "0" })
        : $("#js-container").css({ position: "relative", top: "0" });
    }),
    $("body").hasClass("top") ||
    ($(".js-addHeader").addClass("scroll_on"), $(".addHeader__logo").show()),
    $(".js-nav__btn").on("click", function () {
      var windowWidth = $(window).width(),
        nav_w = $(".nav__inner").outerWidth();
      nav_w = -nav_w;
      var scrollTop = $(window).scrollTop();
      $("#js-container").css({ position: "fixed", top: -scrollTop });
    }),
    $(".js-navItem__trigger").on("click", function () {
      $(this).hasClass("active")
        ? $(this).removeClass("active")
        : $(this).addClass("active"),
        $(this).parent().next("ul").slideToggle();
    }),
    $(".js-navItem__top__trigger").on("click", function () {
      $(".navItem__top.is-items .navItem__title a").trigger("click");
    }),
    $(".js-addHeader__search__trigger").on("click", function () {
      $(".js-addSearch").fadeToggle();
    }),
    $(".js-nav__search__trigger").on("click", function () {
      $(".js-addSearch-nav").fadeToggle();
    });
}),
  window.addEventListener("load", function () {
    $('a[href="#"]').click(function () {
      var adjust = 0,
        speed = 400,
        href = $(this).attr("href"),
        target = $(href == "#" || href == "" ? "html" : href),
        position = target.offset().top + adjust;
      if (href.length == 1) {
        return
      }
      return (
        $("body,html").animate({ scrollTop: position }, speed, "swing"), !1
      );
    });
    var offset = 1e3,
      scrollTop = $("#js-scrollTop");
    $(window).scroll(function () {
      $(this).scrollTop() > offset
        ? scrollTop.fadeIn(500)
        : scrollTop.fadeOut(500);
    });
  });

$(function () {
  const url = window.location.href
  if (window.location.pathname == "/") {
    $('.navItem__top.is-top .navItem__title a , .js-page__top a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('news') > 0 || url.indexOf('blog') > 0) {
    $('.js-page__news a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('legal') > 0) {
    $('.js-page__legal a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('privacy') > 0) {
    $('.js-page__privacy a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('guide') > 0) {
    $('.js-page__guide a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('contact') > 0) {
    $('.js-page__contact a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('search') > 0) {
    if (url.indexOf('sale') > 0) {
      $('.js-cat__sale a').css('color', 'var(--main_5f)');
    }
  }
  if (url.indexOf('atelier') > 0) {
    $('.js-cat__atelier a').css('color', 'var(--main_5f)');
  }


  if (url.indexOf('frontpage') > 0) {
    $('.js-cat__all a').css('color', 'var(--main_5f)');
    $('.js-page__cat a').css('color', 'var(--main_5f)');
  }

  if (url.indexOf('new-item') > 0) {
    $('.js-cat__newarrival a').css('color', 'var(--main_5f)');
    $('.js-page__newarrival a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('outers') > 0) {
    $('.js-cat__outers a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('tops') > 0) {
    $('.js-cat__tops a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('bottoms') > 0) {
    $('.js-cat__bottoms a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('dresses') > 0) {
    $('.js-cat__dresses a').css('color', 'var(--main_5f)');
  }

  
  if (url.indexOf('bags') > 0) {
    $('.js-cat__bags a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('shoes') > 0) {
    $('.js-cat__shoes a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('goods') > 0) {
    $('.js-cat__goods a').css('color', 'var(--main_5f)');
  }
  if (url.indexOf('fragrance') > 0) {
    $('.js-cat__fragrance a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('parfum') > 0) {
    $('.js-cat__fragrance a').css('color', 'var(--main_5f)');
  }
  
  if (url.indexOf('wrapping') > 0) {
    $('.js-cat__gift a').css('color', 'var(--main_5f)');
  }
});

// // 定期的（今回は100ミリ秒間で）に雪を降らせるよう、setInterver関数を使用します
// setInterval(() => {
//   // 雪を作成します（span要素を作成し、それのクラスにballoon_01をあてています）
//   const balloon_01 = document.createElement('span');
//   balloon_01.classList.add('balloon_01');

//   // balloon_01のスタイル（サイズとページ上の左端からの位置）を指定
//   balloon_01.style.width = balloon_01.style.height = Math.random() * 100 + 'px'; // これにより、幅、高さが、～８（正確には８は含まれない）でランダムに指定できます
//   balloon_01.style.left = Math.random() * 100 + '%'; // 雪がページの左端からのどのくらいの距離で位置するようにするかえをランダムで指定

//   // balloon_01-containerにballoon_01を子要素として入れてやる
//   // document.querySelector()するとき、クラスでやるときは、クラス名の前にピリオドが必要です。注意。
//   document.querySelector('.balloon-container').appendChild(balloon_01);

//   // アニメーションの時間が10秒なので、その時間がたったら削除されるようにします

//   setTimeout(() => {
//     // balloon_01を削除します
//     balloon_01.remove();
//   }, 10000 /*ミリ秒指定なので、これで10秒です */);

//   // 風船2個目
//   const balloon_02 = document.createElement('span');
//   balloon_02.classList.add('balloon_02');

//   balloon_02.style.width = balloon_02.style.height = Math.random() * 100 + 'px';
//   balloon_02.style.left = Math.random() * 100 + '%';

//   document.querySelector('.balloon-container').appendChild(balloon_02);

//   setTimeout(() => {
//     balloon_02.remove();
//   }, 10000);

//   // 風船3個目
//   const balloon_03 = document.createElement('span');
//   balloon_03.classList.add('balloon_03');

//   balloon_03.style.width = balloon_03.style.height = Math.random() * 100 + 'px';
//   balloon_03.style.left = Math.random() * 100 + '%';

//   document.querySelector('.balloon-container').appendChild(balloon_03);

//   setTimeout(() => {

//     balloon_03.remove();
//   }, 10000);


// }, 4000 /* 何秒ごとにやるか指定してます*/);


//# sourceMappingURL=/s/files/1/0624/2965/9272/files/ms-common.js.map?v=1712890216%3Fattachment%3D1
